import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errText } from "@/lib/api";
import { Panel, Btn, inputCls, useOps } from "./ui";

function TemplateRow({ t, onSaved }) {
  const { api } = useOps();
  const [subject, setSubject] = useState(t.subject);
  const [body, setBody] = useState(t.body);
  const dirty = subject !== t.subject || body !== t.body;
  const save = async () => { try { await api.put(`/templates/${t.key}`, { subject, body }); toast.success("Saved"); onSaved(); } catch (e) { toast.error(errText(e)); } };
  const reset = async () => { await api.delete(`/templates/${t.key}`); toast.success("Reset to default"); onSaved(); };
  return (
    <Panel title={t.key} testid={`admin-template-${t.key}`} actions={<>
      {t.customized && <span className="text-[10px] text-amber-300">customized</span>}
      {t.customized && <Btn variant="ghost" onClick={reset} data-testid={`template-reset-${t.key}`}>Reset</Btn>}
      <Btn onClick={save} disabled={!dirty} data-testid={`template-save-${t.key}`}>Save</Btn>
    </>}>
      <input className={`${inputCls} mono mb-2`} value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="subject" data-testid={`template-subject-${t.key}`} />
      <textarea className={`${inputCls} mono h-36 text-[12px]`} value={body} onChange={(e) => setBody(e.target.value)} data-testid={`template-body-${t.key}`} />
    </Panel>
  );
}

export default function Templates() {
  const { api } = useOps();
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/templates").then((r) => setData(r.data)), [api]);
  useEffect(() => { load(); }, [load]);
  if (!data) return null;
  return (
    <div data-testid="admin-template-editor" className="space-y-3">
      <p className="text-xs text-slate-400">Plain text only. Variables: <span className="mono text-sky-300">{data.vars}</span></p>
      <div className="grid gap-3 xl:grid-cols-2">
        {data.templates.map((t) => <TemplateRow key={`${t.key}-${t.subject}-${t.body.length}`} t={t} onSaved={load} />)}
      </div>
    </div>
  );
}
